import { render, staticRenderFns } from "./RefundConsult.vue?vue&type=template&id=62ef1cd8&scoped=true&"
import script from "./RefundConsult.vue?vue&type=script&lang=js&"
export * from "./RefundConsult.vue?vue&type=script&lang=js&"
import style0 from "./RefundConsult.vue?vue&type=style&index=0&id=62ef1cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef1cd8",
  null
  
)

export default component.exports